var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"MenuRow"},[_c('router-link',{class:_vm.isCurrentPath ?
      'MenuRow__link MenuRow__link--selected' :
      'MenuRow__link MenuRow__link--deselected',attrs:{"to":{ name: _vm.url }}},[_c('MenuRowIcon',{attrs:{"icon":_vm.icon,"isSelected":_vm.isCurrentPath}}),_c('p',{staticClass:"MenuRow__label"},[_vm._v(_vm._s(_vm.text))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }